export const formConfig = {
  label: "Voucher Form",
  voucherForm: {
    section1: {
      fields: [
        {
          type: "dropdown",
          id: "dec67ee0-ab28-11ef-b856-bc241138112c",
          name: "payee",
          label: "Payee",
          required: 0,
          isMultiSelect: true,
          isShowSearch: true,
          transaction_mode: null,
          option_type: "API",
          metadata: {
            payload: {},
            endpoint: "accounts/vendors/all",
            http_method: "GET",
            query_params: {},
            optional_params: {},
          },
          header_row: 1,
          element_order: 1,
        },
        {
          type_name: "dropdown",
          id: "payment_account",
          type: "dec67ee0-ab28-11ef-b856-bc241138112c",
          name: "payment_account",
          label: "Payment account",
          required: 1,
          isToggleButtons: true,
          transaction_mode: null,
          showSearch: true,
          option_type: "API",
          metadata: {
            payload: {},
            endpoint: "accounts/get-all-coa",
            http_method: "GET",
            query_params: {
              page: "<page_value>",
              org_id: "<org_id_value>",
              pageSize: "<page_size_value>",
              company_id: "<company_id_value>",
              parent_account_code: "<parent_account_code_value>",
            },
            optional_params: {
              page: true,
              pageSize: true,
              parent_account_code: true,
            },
          },
          header_row: 1,
          element_order: 2,
        },
        {
          type_name: "date",
          id: "payment_date",
          type: "dec67ee0-ab28-11ef-b856-bc241138112c",
          name: "payment_date",
          label: "Payment Date",
          required: 1,
          transaction_mode: null,
          option_type: null,
          header_row: 1,
          element_order: 3,
        },
        {
          type_name: "time",
          id: "payment_time",
          type: "dec67ee0-ab28-11ef-b856-bc241138112c",
          name: "payment_time",
          label: "Payment Time",
          required: 1,
          transaction_mode: null,
          option_type: null,
          header_row: 3,
          element_order: 1,
        },
        {
          type_name: "dropdown",
          id: "payment_method",
          type: "dec67ee0-ab28-11ef-b856-bc241138112c",
          name: "payment_method",
          label: "Payment Method",
          showSearch: false,
          required: 1,
          transaction_mode: null,
          option_type: "STATIC",
          options: {
            options: [
              { label: "Cash", value: "Cash" },
              { label: "Check", value: "Check" },
              { label: "Clearing Account", value: "Clearing Account" },
              { label: "Credit Card", value: "Credit Card" },
            ],
          },
          header_row: 1,
          element_order: 4,
        },
        {
          type_name: "text",
          id: "reference_number",
          type: "dec67ee0-ab28-11ef-b856-bc241138112c",
          name: "reference_number",
          label: "Reference Number",
          required: 0,
          transaction_mode: null,
          option_type: null,
          header_row: 1,
          element_order: 5,
        },
        {
          type_name: "dropdown",
          id: "tags",
          type: "dec67ee0-ab28-11ef-b856-bc241138112c",
          name: "tags",
          label: "Tags",
          linkInfo: { label: "Manage Tags", key: "manageTags" },
          required: 1,
          isPersonList: true,
          IsShowSearch: true,
          transaction_mode: null,
          option_type: null,
          header_row: 1,
          element_order: 6,
        },
      ],
    },
    section2: {
      tables: [
        {
          name: "Category Details",
          headers: [
            { label: "#", type: "serial", value: "serial", width: "5%", editable: false },
            { label: "Category", type: "dropdown", value: "category", width: "35%", editable: true },
            { label: "Description", type: "text", value: "description", width: "35%", editable: true },
            { label: "Amount", type: "number", value: "amount", width: "20%", editable: true },
            { label: "Action", type: "action_delete", value: "action", width: "5%", editable: false },
          ],
        },
        {
          name: "Item Details",
          headers: [
            { label: "#", type: "serial", value: "serial", width: "5%", editable: false },
            { label: "Product/Services", type: "dropdown", value: "category", width: "25%", editable: true },
            { label: "Description", type: "text", value: "description", width: "25%", editable: true },
            { label: "Quantity", type: "number", value: "quantity", width: "10%", editable: true },
            { label: "Rate", type: "number", value: "rate", width: "10%", editable: true },
            { label: "Amount", type: "number", value: "amount", width: "20%", editable: true },
            { label: "Action", type: "action_delete", value: "action", width: "5%", editable: false },
          ],
        },
      ],
    },
    section3: {
      fields: [
        {
          id: "memo",
          label: "Memo",
          type_name: "memo",
          value: "",
          placeholder: "Add any additional notes or comments...",
          width: "50%",
          editable: true,
          order: 1,
        },
        {
          id: "attachment",
          label: "Attachment",
          type_name: "file",
          value: null,
          placeholder: "Upload files...",
          width: "50%",
          editable: true,
          order: 2,
        },
      ],
    },
  },
};

export const optionData = ["Privacy", "Print ", "Make Recurring"];

export const options = [
  {
    value: "option1",
    label: "Option 1",
    endAdornment: "Vendor",
    children: [
      {
        value: "option1-1",
        label: "Option 1.1",
        endAdornment: "Vendor",
      },
      {
        value: "option1-2",
        label: "Option 1.2",
        endAdornment: "Info 1.2 Info 1.2 Info 1.2",
        children: [
          {
            startAdornment: "%",
            value: "option1-11",
            label: "Option 1.1",
            endAdornment: "Info 1.1",
          },
          {
            value: "option1-22",
            label: "Option 1.2",
            endAdornment: "Info 1.2",
          },
        ],
      },
    ],
  },
  {
    value: "option2",
    label: "Option 2",
    endAdornment: "Customer",
  },
];
